import { useState, useEffect } from 'react';
import { DeploymentHistory } from '../types';
import { fetchHistory } from '../api';
import { formatDate } from '../utils';

interface HistoryViewProps {
  env: string;
  app: string;
  onBack: () => void;
}

export function HistoryView({ env, app, onBack }: HistoryViewProps) {
  const [history, setHistory] = useState<DeploymentHistory[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    loadHistory();
  }, [env, app]);

  const loadHistory = async () => {
    setLoading(true);
    setError(null);

    try {
      const envApp = `${env}#${app}`;
      const data = await fetchHistory(envApp);
      setHistory(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load history');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="history-view">
      <div className="history-header">
        <button className="back-btn" onClick={onBack}>
          &larr; Back
        </button>
        <h2>Deployment History: {app}</h2>
        <span className="history-env">{env}</span>
      </div>

      {loading && <div className="loading">Loading history...</div>}

      {error && <div className="error">Error: {error}</div>}

      {!loading && !error && (
        <div className="history-table-container">
          <table className="history-table">
            <thead>
              <tr>
                <th>Version</th>
                <th>Deployed At</th>
                <th>Deployed By</th>
                <th>CodeDeploy ID</th>
                <th>Notes</th>
              </tr>
            </thead>
            <tbody>
              {history.length === 0 ? (
                <tr>
                  <td colSpan={5} className="no-data">
                    No history found
                  </td>
                </tr>
              ) : (
                history.map((item, index) => (
                  <tr key={`${item.DeployAt}-${index}`}>
                    <td className="version-cell">{item.Ver}</td>
                    <td>{formatDate(item.DeployAt)}</td>
                    <td>{item.DeployFor}</td>
                    <td>{item.CodeDeployId || '-'}</td>
                    <td className="notes-cell">
                      {item.Notes && item.Notes !== '" "' ? (
                        <span
                          dangerouslySetInnerHTML={{
                            __html: item.Notes.replace(/<br\s*\/?>/gi, '<br/>'),
                          }}
                        />
                      ) : (
                        '-'
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
